module.exports = __webpack_public_path__ + "static/media/Transaction-Declined.49f1317d.svg";